module.exports = __webpack_public_path__ + "static/media/fin4.b29b9e53.jpg";